import { PropsWithChildren } from 'react'

export enum LabelType {
    BLUE = 'blue',
    BLUE_LIGHT = 'blue-light',
    DARK_BLUE_LIGHT = 'dark-blue-light',
    DARKEST_BLUE_LIGHT = 'darkest-blue-light',
    GRAY_LIGHT = 'gray-light',
    VIOLET_LIGHT = 'violet-light',
    SALMON = 'salmon',
    SALMON_LIGHT = 'salmon-light',
    ORANGE_LIGHT = 'orange-light',
    YELLOW_LIGHT = 'yellow-light',
    DARK_GREEN_LIGHT = 'dark-green-light',
    BROWN_LIGHT = 'brown-light',
    GREEN_LIGHT = 'green-light',
    GREEN = 'green',
    ERROR_LIGHT = 'error-light',
    WARNING_LIGHT = 'warning-light',
    WARNING = 'warning',
    SUCCESS_LIGHT = 'success-light',
}

export enum LabelSize {
    DEFAULT = 'default',
    MICRO = 'micro',
}

export interface LabelProps extends PropsWithChildren<unknown> {
    type: LabelType
    size?: LabelSize
}
